import { Component, Input, OnInit } from '@angular/core';
import { ContentElementEnum, GridCell } from '../../../models/sections-model';

@Component({
  selector: 'kw-selectable-features',
  templateUrl: './selectable-features.component.html',
  styleUrls: ['./selectable-features.component.scss']
})
export class SelectableFeaturesComponent implements OnInit {
  @Input() gridCell:GridCell;
  
  constructor() { }

  ngOnInit(): void {
    this.gridCell.contentElements.forEach(contentElement => {
      contentElement.contentElementEnum = ContentElementEnum.ACTION
    })
  }

}
